import styled, { css, keyframes } from 'styled-components';
const slideUpKeyFrames = (left) => keyframes `
  from {
    top: 100%;
  }
      
  to {
    top: ${left};
  }
`;
const slideDownKeyFrames = (left) => keyframes `
  from {
    top:${left};
  }
      
  to {
    top: 100%;
  }
`;
const animateSlideUpFrames = (left) => () => css `
    ${slideUpKeyFrames(left)}
  `;
const animateSlideDownFrames = (left) => () => css `
    ${slideDownKeyFrames(left)}
  `;
const fadeInKeyFrames = keyframes `
  from {
    transform: scale(0);
    opacity: 0;
  }
      
  to {
    transform: scale(1);
    opacity: 1;
  }
`;
const fadeOutKeyFrames = keyframes `
  from {
    transform: scale(1);
    opacity: 1;
  }
      
  to {
    transform: scale(0);
    opacity: 0;
  }
`;
export const Wrapper = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  ${({ animation, $type: type }) => type === 'broadcast' ? (animation ? `position: absolute; top: 110%` : 'width: 100%') : ''};

  ${({ animation, $type: type, positionTop }) => type === 'toast' && animation ? `position: absolute; left: unset; top: ${positionTop}% ` : ''};

  @media ${({ theme }) => theme.device.medium} {
    ${({ animation, $type: type }) => type === 'toast' ? (animation ? `left: calc(50% - 192px);` : '') : ''};
  }

  ${({ $type: type, fade, $height: height }) => {
    return type === 'broadcast'
        ? fade
            ? css `
            animation: ${animateSlideDownFrames(`calc(100% - ${height}px)`)} 0.15s ease-in both;
          `
            : css `
            animation: ${animateSlideUpFrames(`calc(100% - ${height}px)`)} 0.15s ease-in both;
          `
        : '';
}};

  ${({ $type: type, animation, fade }) => {
    return type === 'toast' && animation
        ? fade
            ? css `
            animation: ${fadeOutKeyFrames} 0.15s ease-in-out both;
          `
            : css `
            animation: ${fadeInKeyFrames} 0.15s ease-in-out both;
          `
        : '';
}};
`;
export const StyledNotification = styled.div `
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.grey15};
  color: ${({ theme }) => theme.colors.white};
  ${({ theme }) => `box-shadow: 4px 4px 16px rgba(${theme.colors.transparentBlack}, 0.26);`}
  ${({ $type: type, theme }) => type === 'toast'
    ? `width: 100vw; max-width: 24rem; font-weight: ${theme.fontWeights.regular};`
    : ''};
  ${({ $type: type, hasButton }) => type === 'toast' ? (hasButton ? `height: 4.75rem` : `height: 3.5rem !important`) : ''};

  ${({ $type: type, hasSpinner, theme }) => type === 'toast' && !hasSpinner
    ? `min-width: unset; font-weight: ${theme.fontWeights.regular};`
    : ''};

  ${({ $type: type }) => type === 'banner' ? `flex-direction: column; align-items:flex-start; width: 100vw;` : ''};
  ${({ $type: type }) => (type === 'broadcast' ? `align-items:flex-start;` : '')};

  > div:first-of-type {
    display: flex;
    ${({ $type: type }) => type === 'broadcast' || type === 'banner' ? `align-items:flex-start` : 'align-items: center'};
    ${({ $type: type }) => (type === 'banner' ? `padding-bottom: 0.25rem` : '')};
    ${({ $type: type, hasSpinner }) => type === 'toast' && !hasSpinner
    ? `flex-wrap: wrap; height: 100%; overflow: hidden`
    : 'height: 100%'};
  }

  > div:first-of-type > div {
    word-break: break-word;
    ${({ $type: type }) => (type === 'banner' ? `text-transform: uppercase` : '')};

    ${({ $type: type, hasSpinner }) => type === 'toast' && !hasSpinner
    ? `max-height: 1.25rem`
    : 'display: flex; align-items: center; flex-wrap: wrap; height: 100%; overflow: hidden;'};
    ${({ $type: type }) => (type === 'broadcast' ? `margin: 0 0.5rem 0 0.5rem` : '')};
    ${({ $type: type, hasSpinner }) => type === 'banner' || (type === 'toast' && hasSpinner) ? `margin-left: 0.5rem` : ''};

    @media ${({ theme }) => theme.device.medium} {
      ${({ $type: type }) => (type === 'broadcast' ? `margin: 0 1rem 0 0.5rem` : '')};
    }
  }

  > div:nth-child(2) {
    ${({ $type: type }) => type === 'banner' ? `display: flex; align-items: center; margin-left: auto` : ''};
    ${({ $type: type }) => (type === 'toast' ? `margin-left: 1rem` : '')};
  }

  > div:nth-child(2) button {
    ${({ $type: type }) => type === 'broadcast'
    ? `width: 2.75rem; height: 2.75rem; min-width:2.75rem;
    > span { min-width: 2.75rem; height:2.75rem}`
    : ''};

    @media ${({ theme }) => theme.device.medium} {
      ${({ $type: type }) => type === 'broadcast'
    ? `width: 2.5rem; height: 2.5rem; min-width: 2.5rem; >span { width:2.5rem; min-width: 2.5rem; height:2.5rem}`
    : ''};
    }
  }

  > div:nth-of-type(2) > span {
    margin-left: 0.5rem;
  }

  span {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  span svg {
    width: 1.25rem;
    fill: ${({ theme }) => theme.colors.white};
  }

  @media ${({ theme }) => theme.device.medium} {
    flex: 1;
    padding: 1rem;
    ${({ $type: type }) => type === 'toast' ? `width: 24rem; height: 4.5rem` : 'width: 48rem; height: auto'};
    ${({ $type: type }) => type === 'banner' ? `flex-direction: row; align-items:center; margin-left: unset` : ''};

    > div:first-of-type {
      padding-bottom: 0;
      ${({ $type: type }) => (type === 'banner' ? `align-items:center` : '')};
    }

    > div:nth-of-type(2) > span {
      margin-left: 1rem;
    }
  }

  @media ${({ theme }) => theme.device.large} {
    ${({ $type: type }) => (type === 'toast' ? `width: 24rem;` : 'width: 64rem;')};
    ${({ $type: type }) => (type === 'broadcast' ? `width: 100vw;` : '')};
  }
`;
